"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsLayout = exports.EntityConnectionsLayoutDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_app_layout_1 = require("../../hooks/use-app-layout");
var use_theme_1 = require("../../hooks/use-theme");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var title_case_1 = require("../../utils/title-case");
var use_entity_connections_state_1 = require("../../hooks/use-entity-connections-state");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var use_components_1 = require("../../hooks/use-components");
var entity_graph_1 = require("./entity-graph");
var loader_1 = require("../elements/loader");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var router_1 = require("@reach/router");
var react_spinners_1 = require("react-spinners");
var lodash_1 = require("lodash");
var deepcopy_1 = __importDefault(require("deepcopy"));
var app_logo_1 = require("../app/app-logo");
var content_1 = require("../elements/content");
var entity_connections_toolbar_1 = require("./entity-connections-toolbar");
var entity_connections_banner_1 = require("./entity-connections-banner");
exports.EntityConnectionsLayoutDefaultProps = {
  imageWidth: 8000
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    ", "\n  "], ["\n    display: flex;\n    ", "\n  "])), function (props) {
    return props._height && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var GraphColumnStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var GraphStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["   \n    ", "\n  "], ["   \n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.height);
  }),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GraphContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ToolbarStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SpinnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", ";\n\n    ", "\n  "], ["\n    padding: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(7), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(10));
  })
});
var SectionsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  "], ["\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  "])))
});
var TabsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ActiveSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    background: #FFF;\n    border-left: 1px solid ", ";\n    border-top: 1px solid ", ";\n    align-self: stretch;\n    flex-grow: 1;\n    overflow: auto;\n    \n    ", "\n  "], ["\n    background: #FFF;\n    border-left: 1px solid ", ";\n    border-top: 1px solid ", ";\n    align-self: stretch;\n    flex-grow: 1;\n    overflow: auto;\n    \n    ", "\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('line-subtle'), function (props) {
    return (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var LoaderContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n  "])))
});
var FullscreenBannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    background: #FAFAFA;\n    height: 64px;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    background: #FAFAFA;\n    height: 64px;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5))
});
var AppLogoContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n\n    ", "\n  "], ["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n\n    ", "\n  "])), theme_1.theme.UNIT(1), function (props) {
    return props.hasCustomLogo && (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      svg, img {\n        height: 40px;\n      }\n\n    "], ["\n      svg, img {\n        height: 40px;\n      }\n\n    "])));
  })
});
var AppLogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin-right: ", ";\n\n  "], ["\n    margin-right: ", ";\n\n  "])), theme_1.theme.UNIT(4))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BannerRefStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    min-height: 64px;\n    flex-shrink: 0;\n  "], ["\n    min-height: 64px;\n    flex-shrink: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  BannerRef: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), BannerRefStyles),
  Banner: (0, styled_components_1.default)(entity_connections_banner_1.EntityConnectionsBanner)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  FullscreenBanner: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), FullscreenBannerStyles),
  AppLogoContainer: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), AppLogoContainerStyles),
  AppLogo: (0, styled_components_1.default)(app_logo_1.AppLogo)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), AppLogoStyles),
  LoaderContainer: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LoaderContainerStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Sections: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), SectionsStyles),
  Tabs: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  ActiveSection: styled_components_1.default.div(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ActiveSectionStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  GraphColumn: styled_components_1.default.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), GraphColumnStyles),
  GraphContainer: styled_components_1.default.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), GraphContainerStyles),
  Graph: (0, styled_components_1.default)(entity_graph_1.EntityGraph)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), GraphStyles),
  Toolbar: (0, styled_components_1.default)(entity_connections_toolbar_1.EntityConnectionsToolbar)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), ToolbarStyles),
  Spinner: (0, styled_components_1.default)(react_spinners_1.ClipLoader)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles)
};
var EntityConnectionsLayout = function (props) {
  var className = props.className,
    loading = props.loading,
    imageWidth = props.imageWidth,
    entity = props.entity,
    title = props.title;
  var entities = (0, use_entities_1.useEntities)();
  var entityInfoForSid = (0, react_1.useMemo)(function () {
    return function (sid) {
      var _a = __read((sid || '').split('/'), 2),
        entityTypeSlug = _a[0],
        slug = _a[1];
      if (entityTypeSlug) {
        return {
          slug: slug,
          definition: entities[(0, title_case_1.titleCase)(entityTypeSlug)]
        };
      }
      return {};
    };
  }, [entities]);
  var t = (0, use_lang_1.useLang)();
  var ref = (0, react_1.useRef)();
  var graphRef = (0, react_1.useRef)();
  var _a = __read((0, react_1.useState)(), 2),
    imageData = _a[0],
    setImageData = _a[1];
  var _b = __read((0, react_1.useState)(), 2),
    chartRef = _b[0],
    setChartRef = _b[1];
  var theme = (0, use_theme_1.useTheme)();
  var lineMid = (0, lodash_1.get)(theme, 'color.lineMid', '#CCC');
  var _c = (0, use_app_layout_1.useAppLayout)(),
    availableHeight = _c.availableHeight,
    availableWidth = _c.availableWidth;
  var _d = __read((0, use_dimensions_1.useDimensions)(), 2),
    bannerRef = _d[0],
    bannerInfo = _d[1];
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  var graphHeight = Math.max(100, availableHeight - (bannerInfo.height || 0));
  var _e = __read((0, use_entity_connections_state_1.useEntityConnectionsState)(), 2),
    state = _e[0],
    setState = _e[1];
  var selectedEntity = state.selectedEntity,
    usePagination = state.usePagination,
    spacing = state.spacing,
    zoomed = state.zoomed;
  // const definition = selectedEntity && useEntityDefinition(selectedEntity);
  (0, react_1.useEffect)(function () {
    setState(__assign(__assign({}, state), {
      zoomed: false
    }));
  }, [selectedEntity]);
  var depth = state.depth;
  var graph = selectedEntity && selectedEntity.graph || {
    nodes: [],
    edges: []
  };
  var onDownloadClick = function () {
    if (graphRef && graphRef.current) {
      // @ts-ignore
      var canvasElements = graphRef.current.getElementsByTagName("canvas");
      var canvas = canvasElements && canvasElements.length && canvasElements[0];
      if (canvas && canvas.height !== 0) {
        var c = document.createElement('canvas');
        // set its width&height to the required ones
        var imageHeight = canvas.height / canvas.width * imageWidth;
        c.width = imageWidth;
        c.height = imageHeight;
        // draw our canvas to the new one
        c.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, imageWidth, imageHeight);
        // return the resized canvas dataURL
        var newDataURL = c.toDataURL("image/png");
        var downloadLink = document.createElement('a');
        downloadLink.href = newDataURL;
        downloadLink.download = "connections-".concat(selectedEntity && selectedEntity.slug, ".png");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    }
  };
  var onDepthChange = function (depth) {
    setState(__assign(__assign({}, state), {
      depth: depth
    }));
  };
  var onNodeClick = function (_a) {
    var node = _a.node;
    var _b = entityInfoForSid(node.id),
      slug = _b.slug,
      definition = _b.definition;
    (0, router_1.navigate)(definition.to(slug, 'connections'));
  };
  var onSpacingChange = function (spacing) {
    setState(__assign(__assign({}, (0, deepcopy_1.default)(state)), {
      zoomed: false,
      spacing: spacing
    }));
  };
  var onAutoZoomClick = function () {
    // @ts-ignore
    if (chartRef && chartRef.current) {
      // @ts-ignore
      chartRef.current.zoomToFit(200, 150, function (node) {
        return node.data && node.data.level <= 1;
      });
    }
  };
  var onZoom = function () {
    setState(__assign(__assign({}, state), {
      zoomed: true
    }));
  };
  var velocityDecay = depth === 1 ? 0.6 : 1.1 - spacing * 0.1;
  var components = (0, use_components_1.useComponents)();
  var toolbar = react_1.default.createElement(My.Toolbar, {
    onAutoZoomClick: onAutoZoomClick,
    onSpacingChange: onSpacingChange,
    onDownloadClick: onDownloadClick,
    onDepthChange: onDepthChange,
    depth: depth,
    spacing: spacing
  });
  return react_1.default.createElement(My.Container, {
    ref: ref,
    className: className
  }, react_1.default.createElement(My.GraphColumn, null, react_1.default.createElement(My.BannerRef, {
    ref: bannerRef
  }, react_1.default.createElement(My.Banner, {
    entity: entity,
    controls: [toolbar]
  })), react_1.default.createElement(My.GraphContainer, {
    ref: graphRef
  }, react_1.default.createElement(My.Graph, {
    zoomed: zoomed,
    onZoom: onZoom,
    velocityDecay: velocityDecay,
    depth: depth,
    width: availableWidth,
    height: graphHeight,
    loading: loading,
    onRefChange: function (ref) {
      return setChartRef(ref);
    },
    graph: loading ? {
      nodes: [],
      edges: []
    } : graph,
    usePagination: usePagination,
    sid: selectedEntity && selectedEntity.sid,
    onNodeClick: onNodeClick
  }))));
};
exports.EntityConnectionsLayout = EntityConnectionsLayout;
exports.EntityConnectionsLayout.defaultProps = exports.EntityConnectionsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41;